import { c as _c } from "react/compiler-runtime";
import { Alert } from "@flat-ui";
import { Stack } from "@mui-wrapper";

/**
 * @returns An error alert with an explanation for the project connection error.
 */
export function IntegrationTileError() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Alert variant="error" isCollapsible={true} title="Connection error" description={<Stack spacing={2}><div>This project connection was created in HoloBuilder and needs to be updated for Sphere XG. However, we couldn't complete the update.</div><div>This typically happens when the connected project is no longer available. You can verify your access to the connected project or disable this connection.</div></Stack>} sx={{
      marginBottom: "8px"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}